import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  TextField,
} from '@mui/material'
import { alpha } from '@mui/material/styles'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { MdAdd } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import { GiPayMoney } from 'react-icons/gi'
import { GrMoney } from 'react-icons/gr'
import { TbPigMoney } from 'react-icons/tb'
import { ModalContaAReceber } from './ModalContaAReceber'
import ModalContaAReceberConfirmacao from './ModalContaAReceberConfirmacao'
import PrimeTable from '../../../components/PrimeTable'
import ModalContaAReceberNFSe from './ModalContaAReceberNFSe'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { GlobalContext } from '../../../App'

const filtrosIniciais = {
  acPaciente: null,
  acEmpresa: null,
  dtEmissaoInicial: '',
  dtEmissaoFinal: '',
  dtVencimentoInicial: '',
  dtVencimentoFinal: '',
}

const formataDataFiltro = (data) => (data ? `${data} 00:00:00` : null)

const ContasReceber = () => {
  const { localAtendimento } = useContext(GlobalContext)
  const parametrosBuscaPaciente = useMemo(
    () => ({ idLocalAtendimento: localAtendimento?.[0] }),
    [localAtendimento],
  )
  const [modalConfirmaPagamento, setModalConfirmaPagamento] = useState(false)
  const [modalConfirmaEmiteNota, setModalEmiteNota] = useState(false)
  const [modal, setModal] = useState(false)
  const [tela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [venceHoje, setVenceHoje] = useState(0.0)
  const [totalPagoHoje, setTotalPagoHoje] = useState(0.0)
  const [totalAVencer, setTotalAVencer] = useState(0.0)
  const [totalRecebidoMes, setTotalRecebidoMes] = useState(0.0)
  const [refresh, setRefresh] = useState(0)
  const [habPesquisa, setHabPesquisa] = useState(false)
  const [filtros, setFiltros] = useState(filtrosIniciais)
  const [filtrosAplicados, setFiltrosAplicados] = useState({})
  const emissaoInvalida = !!(
    filtros.dtEmissaoInicial &&
    filtros.dtEmissaoFinal &&
    filtros.dtEmissaoInicial > filtros.dtEmissaoFinal
  )
  const vencimentoInvalido = !!(
    filtros.dtVencimentoInicial &&
    filtros.dtVencimentoFinal &&
    filtros.dtVencimentoInicial > filtros.dtVencimentoFinal
  )
  const [ocultarValores, setOcultarValores] = useState(() => {
    try {
      return (
        localStorage.getItem('financeiro.contaReceber.ocultarValores') ===
        'true'
      )
    } catch {
      return false
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(
        'financeiro.contaReceber.ocultarValores',
        String(ocultarValores),
      )
    } catch {
      // Mantem o controle funcional quando o navegador bloqueia o storage.
    }
  }, [ocultarValores])

  const getList = useCallback(() => {
    metodoPrograma('lista', {}).then((res) => {
      if (res.status) {
        setVenceHoje(res.venceHoje ?? 0)
        setTotalPagoHoje(res.totalPagoHoje ?? 0)
        setTotalAVencer(res.totalAVencer ?? 0)
        setTotalRecebidoMes(res.totalRecebidoMes ?? 0)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setModal(true)
  }

  const clica = () => {
    setDados([])
    setModal(true)
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip
              title={ocultarValores ? 'Mostrar valores' : 'Ocultar valores'}
            >
              <IconButton
                aria-label={
                  ocultarValores ? 'Mostrar valores' : 'Ocultar valores'
                }
                aria-pressed={ocultarValores}
                onClick={() => setOcultarValores((anterior) => !anterior)}
              >
                {ocultarValores ? (
                  <VisibilityOffOutlinedIcon />
                ) : (
                  <VisibilityOutlinedIcon />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title="Adicionar">
              <span>
                <IconButton onClick={() => clica()}>
                  <MdAdd />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Filtrar lançamentos">
              <IconButton
                aria-label="Filtrar lançamentos"
                aria-expanded={habPesquisa}
                color={habPesquisa ? 'primary' : 'default'}
                onClick={() => setHabPesquisa((anterior) => !anterior)}
              >
                <SearchOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>,
        )
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela, ocultarValores, habPesquisa])

  const handleClickConfirmaPagamento = (linha) => {
    setDados(linha)
    setModalConfirmaPagamento(true)
  }

  const handleCloseEmiteNota = () => {
    setModalEmiteNota(false)
  }

  useEffect(() => {
    getList()
  }, [getList, modal, refresh])

  const handleClose = () => {
    setModal(false)
  }

  const handleCloseConfirmaPagamento = () => {
    setModalConfirmaPagamento(false)
  }

  const formatCurrency = (v) =>
    (v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

  return (
    <Programa
      codigo="CtrlContaReceber"
      ferramentas={ferramentas}
      habTrocaLocal={false}
    >
      <Grid container spacing={2} style={{ padding: 25 }}>
        <ModalContaAReceber
          dados={dados}
          show={modal}
          handleClose={handleClose}
          setModal={setModal}
          setRefresh={setRefresh}
        />
        <ModalContaAReceberConfirmacao
          dados={dados}
          show={modalConfirmaPagamento}
          handleClose={handleCloseConfirmaPagamento}
          setModal={setModalConfirmaPagamento}
          setRefresh={setRefresh}
        />
        <ModalContaAReceberNFSe
          dados={dados}
          show={modalConfirmaEmiteNota}
          handleClose={handleCloseEmiteNota}
          setModal={setModalEmiteNota}
          setRefresh={setRefresh}
        />

        <Grid container spacing={2} sx={{ mb: 3 }}>
          {[
            {
              indicador: 'receberHoje',
              titulo: 'A receber hoje',
              valor: venceHoje,
              cor: '#ed8b23',
              Icone: TbPigMoney,
            },
            {
              indicador: 'recebidasHoje',
              titulo: 'Recebidas hoje',
              valor: totalPagoHoje,
              cor: '#2e7d32',
              Icone: GiPayMoney,
            },
            {
              indicador: 'receberMes',
              titulo: 'A receber no mês',
              valor: totalAVencer,
              cor: '#1976d2',
              Icone: GrMoney,
            },
            {
              indicador: 'recebidoMes',
              titulo: 'Recebido no mês',
              valor: totalRecebidoMes,
              cor: '#00897b',
              Icone: GiPayMoney,
            },
          ].map(({ indicador, titulo, valor, cor, Icone }) => (
            <Grid item xs={12} sm={6} lg={3} key={titulo}>
              <Paper
                component="button"
                type="button"
                aria-label={`Filtrar: ${titulo}`}
                aria-pressed={filtrosAplicados.indicador === indicador}
                onClick={() => {
                  setFiltros(filtrosIniciais)
                  setFiltrosAplicados((anterior) =>
                    anterior.indicador === indicador ? {} : { indicador },
                  )
                }}
                elevation={0}
                sx={{
                  width: '100%',
                  textAlign: 'left',
                  font: 'inherit',
                  cursor: 'pointer',
                  px: { xs: 2, md: 2.5 },
                  py: 1.5,
                  height: '100%',
                  boxSizing: 'border-box',
                  borderRadius: 3,
                  bgcolor:
                    filtrosAplicados.indicador === indicador
                      ? alpha(cor, 0.08)
                      : '#fff',
                  border: '1px solid',
                  borderColor:
                    filtrosAplicados.indicador === indicador ? cor : 'grey.200',
                  borderTop: `3px solid ${cor}`,
                  boxShadow: '0 3px 12px rgba(0, 0, 0, 0.06)',
                  transition: 'background-color 150ms, box-shadow 150ms',
                  '&:hover': {
                    bgcolor: alpha(cor, 0.08),
                    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.10)',
                  },
                  '&:focus-visible': {
                    outline: `2px solid ${cor}`,
                    outlineOffset: 3,
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    mb: 0.75,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: '#616161', fontWeight: 500 }}
                  >
                    {titulo}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 32,
                      height: 32,
                      flexShrink: 0,
                      borderRadius: 2,
                      bgcolor: alpha(cor, 0.1),
                      color: cor,
                    }}
                  >
                    <Icone size={19} aria-hidden="true" />
                  </Box>
                </Box>
                <Typography
                  sx={{
                    fontSize: { xs: 24, sm: 22, md: 26 },
                    lineHeight: 1.2,
                    fontWeight: 700,
                    letterSpacing: '-0.5px',
                    fontVariantNumeric: 'tabular-nums',
                    overflowWrap: 'anywhere',
                    color: '#212121',
                  }}
                >
                  {ocultarValores ? '••••••' : formatCurrency(valor)}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        {habPesquisa && (
          <Paper
            variant="outlined"
            sx={{ p: 2, mb: 2, borderRadius: 2, width: '100%' }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {localAtendimento?.[0] ? (
                  <AutoComplete
                    label="Paciente"
                    metodo="buscaPaciente"
                    searchParams={parametrosBuscaPaciente}
                    size="small"
                    value={filtros.acPaciente}
                    onChange={(_, valor) =>
                      setFiltros((anterior) => ({
                        ...anterior,
                        acPaciente: valor,
                      }))
                    }
                  />
                ) : (
                  <TextField
                    label="Paciente"
                    size="small"
                    fullWidth
                    disabled
                    helperText="Aguardando o local de atendimento da sessão."
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <AutoComplete
                  label="Empresa"
                  metodo="buscaEmpresa"
                  size="small"
                  value={filtros.acEmpresa}
                  onChange={(_, valor) =>
                    setFiltros((anterior) => ({
                      ...anterior,
                      acEmpresa: valor,
                    }))
                  }
                />
              </Grid>
              {[
                ['dtEmissaoInicial', 'Emissão inicial', emissaoInvalida],
                ['dtEmissaoFinal', 'Emissão final', emissaoInvalida],
                [
                  'dtVencimentoInicial',
                  'Vencimento inicial',
                  vencimentoInvalido,
                ],
                ['dtVencimentoFinal', 'Vencimento final', vencimentoInvalido],
              ].map(([campo, label, invalido]) => (
                <Grid item xs={12} sm={6} md={3} key={campo}>
                  <TextField
                    type="date"
                    label={label}
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={filtros[campo]}
                    error={invalido}
                    helperText={
                      invalido
                        ? 'O início deve ser anterior ou igual ao fim.'
                        : ''
                    }
                    onChange={(event) =>
                      setFiltros((anterior) => ({
                        ...anterior,
                        [campo]: event.target.value,
                      }))
                    }
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <Box
                  sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}
                >
                  <Button
                    onClick={() => {
                      setFiltros(filtrosIniciais)
                      setFiltrosAplicados({})
                    }}
                  >
                    Limpar filtros
                  </Button>
                  <Button
                    variant="contained"
                    disabled={emissaoInvalida || vencimentoInvalido}
                    onClick={() =>
                      setFiltrosAplicados({
                        idPaciente: filtros.acPaciente?.[0]?.[0] ?? null,
                        idEmpresa: filtros.acEmpresa?.[0]?.[0] ?? null,
                        dtEmissaoInicial: formataDataFiltro(
                          filtros.dtEmissaoInicial,
                        ),
                        dtEmissaoFinal: formataDataFiltro(
                          filtros.dtEmissaoFinal,
                        ),
                        dtVencimentoInicial: formataDataFiltro(
                          filtros.dtVencimentoInicial,
                        ),
                        dtVencimentoFinal: formataDataFiltro(
                          filtros.dtVencimentoFinal,
                        ),
                      })
                    }
                  >
                    Filtrar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              key={JSON.stringify(filtrosAplicados)}
              codigo="CtrlContaReceber"
              action="lista"
              rows={10}
              habSearch
              refresh={refresh}
              head={[
                'Descrição',
                'Paciente',
                'Categoria',
                'Vencimento',
                'Valor Conta',
                'Recebido',
                '',
              ]}
              line={(item) => [
                item[7],
                item[4]?.[1],
                item[1]?.[1],
                item[11],
                item[15],
                item[17],
                '',
              ]}
              columnOptions={[
                ...(ocultarValores
                  ? [
                      { alias: 4, customJsx: () => <span>••••••</span> },
                      { alias: 5, customJsx: () => <span>••••••</span> },
                    ]
                  : []),
                {
                  alias: 6,
                  customJsx: ({ linhaOriginal }) =>
                    linhaOriginal[17] === null ? (
                      <Button
                        onClick={(event) => {
                          event.stopPropagation()
                          handleClickConfirmaPagamento(linhaOriginal)
                        }}
                        fullWidth
                        variant="outlined"
                        color="primary"
                        size="small"
                      >
                        Confirmar
                      </Button>
                    ) : (
                      <></>
                    ),
                },
              ]}
              collumnsDate={[3]}
              collumnsCurrency={[4, 5]}
              parametros={filtrosAplicados}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      </Grid>
    </Programa>
  )
}

export default ContasReceber
